import { Cloud, Database, Folder, Plug, Share2, ShieldCheck, Upload } from "lucide-react";
import type { SourceType } from "@noa/api-core";
import { GoogleDriveIcon } from "./google-drive-icon";

/** Icon per ingestion source. Every key also needs an `admin.uploadAdmin.source` label. */
export const SOURCE_ICONS: Record<SourceType, React.ReactNode> = {
  blob: <Upload size={14} />,
  sharepoint: <Share2 size={14} />,
  maximo: <Database size={14} />,
  conformit: <ShieldCheck size={14} />,
  google_drive: <GoogleDriveIcon size={14} />,
  local: <Folder size={14} />,
  onedrive: <Cloud size={14} />,
  memory: <Database size={14} />,
  api: <Plug size={14} />,
};
